<template>
    <div class="p-3">
        <el-card header="Eventos">
            <ElForm ref="formRef" label-position="top" inline :model="searchData">
                <ElFormItem label="pesquisar" class="col-12 col-md-4 col-lg-3" prop="q">
                    <ElInput name="q" v-model="searchData.q" />
                </ElFormItem>
                <ElFormItem label="Datas dos eventos" class="col-12 col-md-5 col-lg-4" prop="dates">
                    <ElDatePicker type="daterange" range-separator="-" start-placeholder="Desde" end-placeholder="Até" v-model="searchData.dates" />
                </ElFormItem>

                <ElFormItem label="buscar">
                    <ElButton :loading="loading" type="primary" @click="search">Procurar eventos</ElButton>
                </ElFormItem>
            </ElForm>
            <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
                {label: 'Preço normal', prop: 'price'},
                {label: 'Preço VIP', prop: 'vip_price'},
                {label: 'Data', prop: 'event_time'},
            ]" :data="data" >
                <el-table-column label="Local" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.area.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" tag="router-link" :to="'/events/' + data.row.id" icon="View" title="Ver mais"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PersonalTable>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount, reactive, ref } from 'vue'
    import { ElMessageBox, ElForm, ElFormItem, ElInput, ElDatePicker, ElButton, FormInstance, FormRules } from 'element-plus';
    import { useStore } from 'vuex';
    import { Event } from '@/services/types';

    const loading = ref<boolean>(true)
    const data = ref<Array<Event>>([])
    const formRef = ref<FormInstance>()

    const rules = reactive<FormRules<{q: string, dates: Array<string>}>>({
        q: [{required: false, message: 'Selecione a imagem'}],
        dates: [{required: true, message: 'Selecione um intervalo'}]
    })

    const searchData = reactive<{q: string, dates: Array<string>}>({q: '', dates: []})

    const getEvents = async (q: string | false = false, dates: Array<string> | undefined | false = false) => {
        loading.value = true
        const params = new URLSearchParams()
        if (q && q.trim().length > 0) {
            params.append('q', q)
        } 
        if (dates) {
            params.append('start', new Date(dates[0]).toISOString())
            params.append('end', new Date(dates[1]).toISOString())
        }
        const res = await Api.get(`admin/events?${params.toString()}`)
        if (res.status == 200) {
            data.value = res.data.events
        } else {
            console.log(res)
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }

    const search = async () => {
        loading.value = true
        await getEvents(searchData.q, searchData.dates)
    }
    onBeforeMount(async () => {
        await getEvents()
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 2) {
            // new product
            await getEvents()
        }
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
